"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTestRunsUrlPath = exports.getCommonAppBaseURL = exports.getBaseUrl = exports.DEFAULT_DATADOG_SUBDOMAIN = void 0;
const api_1 = require("./api");
const tags_1 = require("./tags");
exports.DEFAULT_DATADOG_SUBDOMAIN = 'app';
const getBaseUrl = () => {
    const site = (0, api_1.getDatadogSite)();
    const subdomain = process.env.DD_SUBDOMAIN || '';
    return (0, exports.getCommonAppBaseURL)(site, subdomain);
};
exports.getBaseUrl = getBaseUrl;
const getCommonAppBaseURL = (datadogSite, subdomain) => {
    const validSubdomain = subdomain || exports.DEFAULT_DATADOG_SUBDOMAIN;
    const datadogSiteParts = datadogSite.split('.');
    if (datadogSiteParts.length === 3) {
        if (validSubdomain === exports.DEFAULT_DATADOG_SUBDOMAIN) {
            return `https://${datadogSite}/`;
        }
        return `https://${validSubdomain}.${datadogSiteParts[1]}.${datadogSiteParts[2]}/`;
    }
    return `https://${validSubdomain}.${datadogSite}/`;
};
exports.getCommonAppBaseURL = getCommonAppBaseURL;
const getTestRunsUrlPath = (spanTags, queryPrefix = '') => {
    if (!spanTags[tags_1.CI_PIPELINE_URL] && !spanTags[tags_1.CI_JOB_URL]) {
        return '';
    }
    let query = queryPrefix;
    if (spanTags[tags_1.CI_JOB_URL]) {
        query += ` @ci.job.url:"${spanTags[tags_1.CI_JOB_URL]}"`;
    }
    else if (spanTags[tags_1.CI_PIPELINE_URL]) {
        query += ` @ci.pipeline.url:"${spanTags[tags_1.CI_PIPELINE_URL]}"`;
    }
    return `ci/test-runs?query=${encodeURIComponent(query)}`;
};
exports.getTestRunsUrlPath = getTestRunsUrlPath;
//# sourceMappingURL=app.js.map